import { useFormikContext } from "formik";
import AuthField from "components/v2/Auth/AuthField";
import { countries, institutionLevels } from "utils/data";
import { createUsername } from "./register_utils";

const RegistrationFields = ({ institution = false, provinces = [], isLoadingProvinces }) => {
	const { values, setFieldValue } = useFormikContext();
	const updateUsername = (event) => {
		const firstName = event.target.name === "first_name" ? event.target.value : values.first_name;
		const lastName = event.target.name === "last_name" ? event.target.value : values.last_name;
		setFieldValue("username", createUsername(`${firstName}.${lastName}`));
	};
	return (
		<>
			<section className="auth-section" aria-labelledby="auth-personal-heading">
				<h3 id="auth-personal-heading" className="auth-section__title">{institution ? "Your details" : "About you"}</h3>
				<div className="auth-fields-grid">
					<AuthField name="first_name" label="First name*" onInput={updateUsername} placeholder="First name" />
					<AuthField name="last_name" label="Last name*" onInput={updateUsername} placeholder="Last name" />
				</div>
				<AuthField name="email" type="email" label="Email address*" placeholder="you@example.com" />
				<AuthField name="mobile_number" type="phone" label="Phone number*" />
				{!institution && (
					<div className="auth-fields-grid">
						<AuthField name="dob" type="date" label="Date of birth" helperText="Optional" />
						<AuthField name="sex" type="select" label="Gender*" options={[{ label: "Male", value: "Male" }, { label: "Female", value: "Female" }]} />
					</div>
				)}
			</section>
			<section className="auth-section" aria-labelledby="auth-account-heading">
				<h3 id="auth-account-heading" className="auth-section__title">Account details</h3>
				<AuthField name="username" label="Username*" helperText="Already use Smart Learning? Use the same username." />
				<div className="auth-fields-grid">
					<AuthField name="password" type="password" label="Password*" helperText="6+ characters, including a letter and a number." />
					<AuthField name="password_confirmation" type="password" label="Confirm password*" />
				</div>
			</section>
			{institution && (
				<section className="auth-section" aria-labelledby="auth-institution-heading">
					<h3 id="auth-institution-heading" className="auth-section__title">Your institution</h3>
					<div className="auth-fields-grid">
						<AuthField name="name" label="Institution name*" />
						<AuthField name="level" type="select" label="Institution level*" options={institutionLevels.map((level) => ({ label: level.name, value: level.value }))} />
					</div>
					<div className="auth-fields-grid">
						<AuthField name="country" type="select" label="Country*" options={countries.map((country) => ({ label: country.name, value: country.name }))} />
						{values.country === "Zimbabwe" && <AuthField name="province" type="select" label="Province*" isLoading={isLoadingProvinces} options={provinces.map((province) => ({ label: province.name, value: province.name }))} />}
					</div>
				</section>
			)}
		</>
	);
};

export default RegistrationFields;
